<template>
  <div class="flex bg-white p-1 my-1 flex-wrap flex-col border-default">
    <div class="smart-icon justify-start w-full relative">
      <SmartIcon
        :size="8"
        type="big"
      />
      <SmartTag
        class="absolute pin-t pin-r mt-1"
        :label="labelTag"
      />
    </div>

    <div class="smart-content mt-2 w-full px-1">
      <div class="content-main">
        <SmartTitle weight="medium">
          {{ heading }}
        </SmartTitle>
        <SmartP class="mt-1-4 mb-2">
          {{textP}}
        </SmartP>
      </div>

      <div class="content-button mt-3 mb-2">
        <SmartButton secondary>
          {{ labelButton }}
        </SmartButton>
      </div>
    </div>
  </div>
</template>

<script>
// @flow
export default {
  components: {
    SmartButton: () => import('packages/SmartButton'),
    SmartTag: () => import('packages/SmartTag'),
    SmartP: () => import('packages/SmartP'),
    SmartIcon: () => import('packages/SmartIcon'),
    SmartTitle: () => import('packages/SmartTitle')
  },

  props: {
    heading: {
      type: String,
      default: 'Heading',
      required: true
    },
    labelTag: {
      type: String,
      default: 'Label text here',
      required: true
    },
    textP: {
      type: String,
      default: 'Text paragraph here',
      required: true
    },
    labelButton: {
      type: String,
      default: 'Label button here',
      required: true
    }

  }
};
</script>

<style lang="scss">
.smart {
  padding: $spacing-padding-xxsmall;
}

.content-main {
  border-bottom: 1px solid rgba($color-ui-black, $opacity-low-min);
  h2 {
    letter-spacing: .2px;
  }
}

</style>
